import type { NavigationGuard } from "vue-router";
import { useAuthStore } from "@/stores/auth";

export const authGuard: NavigationGuard = (to, _from, next) => {
  const auth = useAuthStore();
  if (!auth.isSignedIn) {
    next({ name: "signin", query: { redirect: to.fullPath } });
    return;
  }
  if (!auth.isAllowedDomain) {
    next({ name: "wrong-domain" });
    return;
  }
  next();
};

export function roleGuard(...allowed: Array<"admin" | "viewer" | "user">): NavigationGuard {
  return (to, _from, next) => {
    const auth = useAuthStore();
    if (!auth.isSignedIn) {
      next({ name: "signin", query: { redirect: to.fullPath } });
      return;
    }
    if (!auth.isAllowedDomain) {
      next({ name: "wrong-domain" });
      return;
    }
    if (!allowed.includes(auth.role)) {
      next({ name: "forbidden" });
      return;
    }
    next();
  };
}
